<div fxLayout="row wrap" fxLayoutAlign="space-around center" fxLayoutGap="15px grid" style="padding: 10px">
  <div fxFlex="100">
    <abcInput
      #designationInput
      [style]="4"
      [id]="'Designation'"
      [value]="''"
      [placeholder]="res('DocumentsEditorCardDetails-Designation')"
      [width]="'100%'"
      [height]="'40px'"
      [(value)]="customFileName"
    ></abcInput>
  </div>
  <div fxFlex="67">
    <abc-drop-down-box
      #documentKindDropDownBox
      [label]="res('DocumentsEditorCardDetails-DocumentKind')"
      [id]="'Kind'"
      [dataSource]="documentKindData"
      [displayExpr]="'Description'"
      [valueExpr]="'Value'"
    >
    </abc-drop-down-box>
  </div>
  <div fxFlex="33">
    <abcDatepicker
      #dateInput
      [id]="'Date'"
      [style]="4"
      [placeholder]="res('DocumentsEditorCardDetails-Date')"
      [width]="'100%'"
      [height]="'40px'"
    >
    </abcDatepicker>
  </div>
  <div fxFlex="90" class="filename-uploader">
    <abc-text-box #fileNameUploaderTextBox [width]="'100%'" [placeholder]="res('DocumentsEditorCardDetails-Filename')">
    </abc-text-box>
  </div>
  <div fxFlex="">
    <abc-file-uploader
      class="fileUploaderStyle"
      [width]="'100%'"
      [height]="'100%'"
      [showFileList]="false"
      (onValueChanged)="uploadFileData($event)"
    >
    </abc-file-uploader>
  </div>
</div>
<div
  fxLayout="row wrap"
  fxLayoutAlign="space-around center"
  fxLayoutGap="15px grid"
  style="padding: 10px"
  [ngStyle]="{ display: displayDetailsFields ? 'flex' : 'none' }"
>
  <div fxFlex="33">
    <abc-drop-down-box
      #dataCarrierDropDownBox
      [label]="res('DocumentsEditorCardDetails-DataCarrier')"
      [id]="'Media'"
      [dataSource]="documentCarrierData"
      [displayExpr]="'Description'"
      [valueExpr]="'Value'"
      [(value)]="dataCarrierValue"
    >
    </abc-drop-down-box>
  </div>
  <div fxFlex="">
    <abcInput
      #numberInput
      [id]="'Number'"
      [type]="'number'"
      [style]="4"
      [placeholder]="res('DocumentsEditorCardDetails-Number')"
      [width]="'100%'"
      [height]="'40px'"
      (onChange)="onNumberchange($event)"
    >
    </abcInput>
  </div>
  <div fxFlex="100">
    <abcInput
      #programPathInput
      [id]="'ProgramPath'"
      [style]="4"
      [placeholder]="res('DocumentsEditorCardDetails-ProgramPath')"
      [width]="'100%'"
      [height]="'40px'"
      (onChange)="onProgramPathchange($event)"
    ></abcInput>
  </div>
  <div fxFlex="33">
    <abcDatepicker
      #validFromInput
      [id]="'DateStart'"
      [style]="4"
      [placeholder]="res('DocumentsEditorCardDetails-ValidFrom')"
      [width]="'100%'"
      [height]="'40px'"
      (onChange)="onValidFromInputchange($event)"
    ></abcDatepicker>
  </div>
  <div fxFlex="33">
    <abcDatepicker
      #validUntilInput
      [id]="'DateEnd'"
      [style]="4"
      [placeholder]="res('DocumentsEditorCardDetails-ValidUntil')"
      [width]="'100%'"
      [height]="'40px'"
      (onChange)="onValidUntilInputchange($event)"
    ></abcDatepicker>
  </div>
  <div fxFlex=""></div>
  <div fxFlex="100">
    <abcTextArea
      #Comment
      [id]="'Comment'"
      [width]="'100%'"
      [height]="'111px'"
      [placeholder]="res('DocumentsEditorCardDetails-Comment')"
      (onChange)="onCommentChange($event)"
    >
    </abcTextArea>
  </div>

  <div fxFlex="50">
    @if (document?.InsertDate) {
      <label>{{ res('DocumentsEditorCardDetails-InsertedOn') }}: </label>
    }
    <span>{{ document?.InsertDate }}</span>
  </div>
  <div fxFlex="50">
    @if (document?.UpdateDate) {
      <label>{{ res('DocumentsEditorCardDetails-LastUpdateOn') }}: </label>
    }
    <span>{{ document?.UpdateDate }}</span>
  </div>
</div>

<div fxLayout="row" fxLayoutGap="10px" class="docActionButtons" fxLayoutAlign="end center">
  @if (displayDetailsFields) {
    <abcButton
      [id]="'button-Reset'"
      [style]="4"
      [width]="'120px'"
      [height]="'30px'"
      [value]="res('DocumentsEditorCardDetails-Reset')"
      (click)="resetButton()"
    >
    </abcButton>
  }
  <abcButton
    [id]="'button-Ok'"
    [style]="4"
    [width]="'120px'"
    [height]="'30px'"
    [value]="res('DocumentsEditorCardDetails-Ok')"
    (click)="okButton()"
    [disabled]="isOkBtnDisabled"
  >
  </abcButton>
  <abcButton
    [id]="'button-Cancel'"
    [style]="4"
    [width]="'120px'"
    [height]="'30px'"
    [value]="res('DocumentsEditorCardDetails-Cancel')"
    (click)="cancelButton()"
  >
  </abcButton>
</div>
